import { WarehouseCodes } from '../interfaces/inventory';
const ENV_DEVELOPMENT = 'development';
const ENV_PRODUCTION = 'production';
const ENV_TEST = 'test';
const SWAG_SERVER_TEST = 'test';
const SWAG_SERVER_PROD = 'prod';
const SWAG_SERVER_STAGING = 'staging';
const SWAG_SERVER_SANDBOX = 'sandbox';
const SWAG_SERVER_DEVELOPMENT = 'development';
const SWAG_PROD = 'swag-prod';
const SWAG_TEST = 'swag-test';
const SWAG_STAGING = 'swag-staging';
const SWAG_DEVELOPMENT = 'swag-dev';
const DEFAULT_PROCESS_TITLE = 'node';
const KS_FLOW_ID = 'kickstarter';
const DEFAULT_CURRENCY = 'USD';

/* PRODUCT */
const MAX_LOGO_COLORS = 8;
const PRINT_RUN_COLORS = new Array(MAX_LOGO_COLORS).fill(0).map((v, i) => i + 1);
const PRODUCTION_TIME_STANDARD_INDEX = 0;
const PRODUCTION_TIME_STANDART_VALUE = 0;
const PRODUCTION_TIME_STANDART_DAYS = 10;
const PRODUCTION_TIME_STANDART_TEXT = 'Standard';
const PRODUCTION_TIME_PRIORITY_VALUE = 0.1;
const PRODUCTION_TIME_PRIORITY_DAYS = 5;
const PRODUCTION_TIME_PRIORITY_TEXT = 'Priority';
const PRODUCTION_TIME_VIP_VALUE = 0.25;
const PRODUCTION_TIME_VIP_DAYS = 3;
const PRODUCTION_TIME_VIP_TEXT = 'VIP';
const DISCOUNT_VALUE = 0.1;
const FULFILLIFY_INNER_WAREHOUSE_DIGIT_CODE = {
  [WarehouseCodes.ROC]: 11,
  [WarehouseCodes.MEC]: 14,
  [WarehouseCodes.WHIPLASH]: 59
  // [WarehouseCodes.OKL]: 15,
};

const PRODUCTION_TIME_LIST = [{
  name: PRODUCTION_TIME_STANDART_TEXT,
  cost: PRODUCTION_TIME_STANDART_VALUE,
  time: PRODUCTION_TIME_STANDART_DAYS
}, {
  name: PRODUCTION_TIME_PRIORITY_TEXT,
  cost: PRODUCTION_TIME_PRIORITY_VALUE,
  time: PRODUCTION_TIME_PRIORITY_DAYS
}, {
  name: PRODUCTION_TIME_VIP_TEXT,
  cost: PRODUCTION_TIME_VIP_VALUE,
  time: PRODUCTION_TIME_VIP_DAYS
}];
const ACCUMULATOR_TAG = {
  PATAGONIA: 'patagonia'
};
const STRIPE_ERRORS = {
  API_CONNECTION: 'api_connection_error',
  API: 'api_error',
  AUTHENTICATION: 'authentication_error',
  CARD: 'card_error',
  IDEMPOTENCY: 'idempotency_error',
  INVALID_REQUEST: 'invalid_request_error',
  RATE_LIMIT: 'rate_limit_error'
};

/* IMAGE UPLOADING */
const IMAGE_EXTENSIONS = ['.eps', '.jpg', '.jpeg', '.png'];
const MIME_TYPES = [
// EPS
'application/postscript', 'application/eps', 'application/x-eps', 'image/eps', 'image/x-eps', 'image/jpeg', 'image/jpg', 'image/png'];
const KS_BAKERS_FIELDS = ['Backer Number', 'Backer UID', 'Backer Name', 'Email', 'Shipping Country', 'Shipping Amount', 'Reward Title', 'Shipping Name', 'Shipping Address 1', 'Shipping Address 2', 'Shipping City', 'Shipping State', 'Shipping Postal Code', 'Shipping Country Name', 'Shipping Country Code', 'T-shirt Size'];
const KS_BAKERS_FIELDS_REPLACE_KEYS = [{
  from: 'T-shirt Size',
  to: 'Size'
}];
const KS_BAKERS_FIELDS_RESULT = ['Backer Number', 'Backer UID', 'Backer Name', 'Email', 'Shipping Country', 'Shipping Amount', 'Reward Title', 'Shipping Name', 'Shipping Address 1', 'Shipping Address 2', 'Shipping City', 'Shipping State', 'Shipping Postal Code', 'Shipping Country Name', 'Shipping Country Code', 'T-shirt Size'];
const KS_TEMPLATE_FIELDS = ['Order Number', 'Element ID', 'Element Description', 'Qty Fulfilled', 'Recipient Company', 'Recipient First Name', 'Recipient last name', 'Recipient Address', 'Recipient City', 'Recipient State', 'Recipient Country', 'Recipient Zip', 'Recipient Phone', 'Recipient Email', 'Sender Company', 'Sender First Name', 'Sender last name', 'Sender Address', 'Sender City', 'Sender State', 'Sender Zip', 'Sender Phone', 'Sender Email', 'Billing Company', 'Billing FirstName', 'Billing LastName', 'Billing Address', 'Billing City', 'Billing State', 'Billing Zip', 'Billing Phone', 'Billing Email'];
const KS_SIZE_DICTIONARY = {
  S: 'Small',
  M: 'Medium',
  L: 'Large',
  XL: 'XLarge',
  XXL: 'XXLarge',
  XXXL: 'XXXLarge'
};
const KS_TRACKING_FIELDS = ['Warehouse', 'Customer Order#', 'Transaction Number', 'Sequence Number', 'Status', 'StockNumber', 'Description', 'Order Qty', 'Shipped Qty', 'Ship Date', 'Recipient', 'Phone', 'Email', 'Company', 'Address', 'City', 'State', 'Country', 'Zip', 'Create Date', 'Created By', 'Order By', 'Carrier', 'Shipping Method', 'Shipping Charge', 'Tracking Number'];
const KS_TRACKING_DB_FIELDS = {
  name: 'Recipient',
  trNum: 'Tracking Number'
};
const MAX_ATTACHMENTS_COUNT_PER_ITEM = 5;
const SWAG_SERVER = process.env.SWAG_SERVER;
const NODE_ENV = process.env.NODE_ENV;
const IS_PRODUCTION = SWAG_SERVER === SWAG_SERVER_PROD && NODE_ENV === ENV_PRODUCTION;
const IS_TEST = SWAG_SERVER === SWAG_SERVER_TEST && NODE_ENV === ENV_PRODUCTION;
const IS_STAGING = SWAG_SERVER === SWAG_SERVER_STAGING && NODE_ENV === ENV_PRODUCTION;
const IS_SANDBOX = SWAG_SERVER === SWAG_SERVER_SANDBOX && NODE_ENV === ENV_PRODUCTION;
const IS_DEVELOPMENT = NODE_ENV === ENV_DEVELOPMENT;
const IS_INTEGRATION_TEST = (NODE_ENV || ENV_DEVELOPMENT) === ENV_TEST;
const SHOULD_CHANGE_PROCESS_TITLE = !(IS_DEVELOPMENT || IS_INTEGRATION_TEST);
export let TENANT_EMAIL_TRANSPORTS = /*#__PURE__*/function (TENANT_EMAIL_TRANSPORTS) {
  TENANT_EMAIL_TRANSPORTS["api"] = "api";
  TENANT_EMAIL_TRANSPORTS["defaultSwag"] = "defaultSwag";
  return TENANT_EMAIL_TRANSPORTS;
}({});
export const SENDOSO_SYSTEM_USER_ROLE = 'external_inventory_manager';
export const BUNDLE_TYPE_HEADER_NAME = 'x-tenant-id'; // This is a technical debt
export const CUSTOM_INK_HEADER_NAME = 'x-custom-ink-pro';
export const TENANT_STORE_HEADER_NAME = 'x-tenant-store-name';
const WAREHOUSE_ORDERS_URL = 'https://portal.fulfillify.com/Orders/Search';
export const WORKER_TIMEOUT_INTERVAL = 60000;
export const ELASTICSEARCH_REQUEST_TIMEOUT = 30000;
export const WHIPLASH_GET_PRODUCTS_PAGE_SIZE = 250;
export { ENV_DEVELOPMENT, ENV_PRODUCTION, ENV_TEST, SWAG_SERVER_TEST, SWAG_SERVER_PROD, SWAG_SERVER_STAGING, SWAG_SERVER_SANDBOX, SWAG_SERVER_DEVELOPMENT, SWAG_PROD, SWAG_TEST, SWAG_STAGING, SWAG_DEVELOPMENT, KS_FLOW_ID, MAX_LOGO_COLORS, PRINT_RUN_COLORS, PRODUCTION_TIME_STANDARD_INDEX, PRODUCTION_TIME_STANDART_VALUE, PRODUCTION_TIME_STANDART_DAYS, PRODUCTION_TIME_STANDART_TEXT, PRODUCTION_TIME_PRIORITY_VALUE, PRODUCTION_TIME_PRIORITY_DAYS, PRODUCTION_TIME_PRIORITY_TEXT, PRODUCTION_TIME_VIP_VALUE, PRODUCTION_TIME_VIP_DAYS, PRODUCTION_TIME_VIP_TEXT, DISCOUNT_VALUE, PRODUCTION_TIME_LIST, IMAGE_EXTENSIONS, MIME_TYPES, KS_BAKERS_FIELDS, KS_BAKERS_FIELDS_REPLACE_KEYS, KS_BAKERS_FIELDS_RESULT, KS_TEMPLATE_FIELDS, KS_SIZE_DICTIONARY, KS_TRACKING_FIELDS, KS_TRACKING_DB_FIELDS, MAX_ATTACHMENTS_COUNT_PER_ITEM, STRIPE_ERRORS, ACCUMULATOR_TAG, DEFAULT_CURRENCY, IS_PRODUCTION, IS_TEST, IS_STAGING, IS_SANDBOX, IS_DEVELOPMENT, IS_INTEGRATION_TEST, FULFILLIFY_INNER_WAREHOUSE_DIGIT_CODE, WAREHOUSE_ORDERS_URL, DEFAULT_PROCESS_TITLE, SHOULD_CHANGE_PROCESS_TITLE };